type StackOverviewPromptArguments = {
  stackId: string;
};

export const buildStackOverviewPrompt = ({ stackId }: StackOverviewPromptArguments): string =>
  `Give me a quick overview of Spacelift stack \`${stackId}\`: its current state including any drift or active lock, the outcome of the last 5 runs with the reason for any failure, and anything that needs my attention right now.`;

export const STACK_CREATION_PROMPT =
  "Help me create a new Spacelift stack. Walk me through what you need — repository, branch, project root, vendor and workflow — and create the stack once we have the details.";

export const POLICY_CREATION_PROMPT =
  "Help me create a new Spacelift policy. Walk me through what you need: the policy type (plan, approval, push, notification, trigger and so on), the rules it should enforce, the space it lives in and which stacks it should attach to, directly or by autoattach labels. Then draft it in Rego v1 and create the policy once we agree on the rules.";

type PolicyOverviewPromptArguments = {
  policyId: string;
};

export const buildPolicyOverviewPrompt = ({ policyId }: PolicyOverviewPromptArguments): string =>
  `Give me a quick overview of Spacelift policy \`${policyId}\`: what its rules allow, deny or warn about in plain words, which stacks it is attached to (directly or by autoattach labels), what its recent samples show, and anything that needs my attention, like risky rules or Rego v0 syntax.`;

export const LOGIN_POLICY_CREATION_PROMPT =
  "Help me create a new Spacelift login policy. It lives in the root space and is not attached to stacks. Walk me through what you need: who can log in, who gets admin, and which spaces each user or team can read, write or administer. Then draft it in Rego v1, test it against sample logins so nobody gets locked out by mistake, and create it once we agree on the rules.";

type LoginPolicyOverviewPromptArguments = {
  policyId: string;
};

export const buildLoginPolicyOverviewPrompt = ({
  policyId,
}: LoginPolicyOverviewPromptArguments): string =>
  `Give me a quick overview of Spacelift login policy \`${policyId}\`: who it lets log in, who it makes admin and which spaces it gives access to, in plain words, what its recent samples show, and anything that needs my attention, like rules that could lock people out, Rego v0 syntax, or login policies not being evaluated because Identity Access Management is the active strategy.`;
